import type { SelectionState } from "#/game/selection/types";

type MovePreviewSelection = Extract<SelectionState, { mode: "move-preview" }>;

export function movePreviewFromSelection(selection: SelectionState): MovePreviewSelection | null {
  if (selection.mode === "move-preview") return selection;
  return null;
}
